var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_535_17281)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0628 6.76057C27.8866 5.34533 24.3381 4.99473 20.9463 5.76105C17.5546 6.52737 14.5014 8.36955 12.2422 11.0128C9.98296 13.6561 8.63871 16.9589 8.40992 20.4286C8.18113 23.8983 9.08005 27.349 10.9726 30.2661C12.8652 33.1832 15.65 35.4103 18.9118 36.6153C22.1735 37.8204 25.7374 37.9388 29.072 36.9529C32.4065 35.9669 35.333 33.9295 37.415 31.1445C39.497 28.3595 40.623 24.976 40.625 21.4988V19.8515C40.625 18.862 41.4271 18.0598 42.4166 18.0598C43.4061 18.0598 44.2083 18.862 44.2083 19.8515V21.4998C44.2059 25.7498 42.8297 29.8861 40.285 33.29C37.7403 36.694 34.1635 39.1841 30.088 40.3891C26.0124 41.5941 21.6566 41.4494 17.67 39.9766C13.6834 38.5038 10.2797 35.7817 7.96656 32.2164C5.6534 28.6511 4.55471 24.4336 4.83435 20.1929C5.11398 15.9521 6.75695 11.9154 9.51824 8.68468C12.2795 5.45398 16.0112 3.20243 20.1566 2.26582C24.3021 1.32921 28.6392 1.75772 32.5213 3.48745C33.4251 3.89018 33.8313 4.94937 33.4286 5.85322C33.0259 6.75706 31.9667 7.1633 31.0628 6.76057ZM43.6829 5.89897C44.3829 6.59831 44.3835 7.73273 43.6842 8.43277L25.7675 26.3674C25.4316 26.7036 24.9758 26.8926 24.5004 26.8928C24.0251 26.8929 23.5692 26.7041 23.2331 26.368L17.8581 20.993C17.1584 20.2933 17.1584 19.1589 17.8581 18.4592C18.5578 17.7595 19.6922 17.7595 20.3919 18.4592L24.4993 22.5667L41.1491 5.90024C41.8484 5.2002 42.9829 5.19963 43.6829 5.89897Z",
    fill: "#383752"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_535_17281",
    x: -1,
    y: 0,
    width: 51,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_535_17281"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_535_17281",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.cd807805a9b5f2127ea0bbcbb03f9f11.svg";
export { ForwardRef as ReactComponent };